import React from "react";
import { classNames } from "../../shared/utility";
import { InputText } from "primereact/inputtext";
import type { InputTextProps } from "primereact/inputtext";

interface InputTextOnlyProps extends Omit<InputTextProps, "className"> {
  parentClass?: string;
  className?: string;
  label?: React.ReactNode;
  labelOn?: boolean;
  error?: string;
  explanation?: React.ReactNode;
  labelClass?: string;
  suffix?: React.ReactNode;
}

export default function InputTextOnly(props: InputTextOnlyProps) {
  const {
    parentClass,
    className,
    label,
    name,
    onChange,
    type,
    value,
    labelOn,
    error,
    suffix,
    explanation,
    labelClass,
    ...other
  } = props;

  return (
    <div className={parentClass || undefined}>
      {labelOn ? (
        <label
          htmlFor={name}
          className={classNames(
            labelClass ? labelClass : "text-sm",
            "block font-medium text-gray-900 mb-2"
          )}
        >
          {label}
        </label>
      ) : null}
      <div>
        <InputText
          name={name}
          className={classNames(className, "w-full")}
          value={value}
          onChange={onChange}
          {...other}
        />

        {error ? <p className="font-medium text-red-500 mt-1 text-sm">{error}</p> : null}
      </div>
    </div>
  );
}
